export const parseJwt = (token: string) => {
  if (!token) {
    return null
  }
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch (e) {
    return null
  }
}
